import { storage } from './storage.js';
const STORAGE_KEY = 'crmTenant';
export const createCrmTenantSlice = (set) => ({
    crmTenant: null,
    setCrmTenant: (context) => {
        if (context === null) {
            storage.removeItem(STORAGE_KEY);
            set({ crmTenant: null });
            return;
        }
        storage.setItem(STORAGE_KEY, JSON.stringify(context), false);
        set({ crmTenant: context });
    },
    hydrateCrmTenant: async () => {
        const raw = await storage.getItem(STORAGE_KEY);
        if (!raw)
            return;
        try {
            const parsed = JSON.parse(raw);
            if (!isCrmTenantContext(parsed))
                return;
            set({ crmTenant: parsed });
        }
        catch {
            // ignore invalid JSON
        }
    },
    clearCrmTenant: () => {
        storage.removeItem(STORAGE_KEY);
        set({ crmTenant: null });
    },
});
function isCrmTenantContext(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return false;
    const rec = value;
    return (typeof rec.tenantId === 'string' &&
        typeof rec.tenantSlug === 'string' &&
        typeof rec.tenantName === 'string');
}
//# sourceMappingURL=crmTenantSlice.js.map